export const splitPathParts = (pathname: string): string[] =>
  (pathname || "").split("/").filter(Boolean);

export const isTenDigitModelId = (value: string | null | undefined): boolean =>
  !!value && /^\d{10}$/.test(value);

export const extractYearFromPeriodParam = (periodParam: string | null): string | null => {
  if (!periodParam) return null;
  const decodedPeriod = decodeURIComponent(periodParam).trim();
  const m = decodedPeriod.match(/(?:^|\s|\/)(20\d{2})(?:\s|$|\/)/);
  return m ? m[1] : null;
};

export const extractElementModelId = (meaId: string | null | undefined): string | null => {
  if (!meaId) return null;
  const m = meaId.match(/^SC\.(\d{10})\./);
  return m ? m[1] : null;
};

export const extractPageFromPathParts = (args: {
  pathParts: string[];
  tenantSymbol: string;
  modelId?: string | null;
  fallback?: string;
}): string => {
  const { pathParts, tenantSymbol, modelId, fallback = "landingpage" } = args;
  // Format: /{tenant}/{model}/{page}/...
  if (pathParts.length >= 3 && pathParts[0] === tenantSymbol) {
    const candidate = pathParts[2];
    if (candidate && !/^\d{10}$/.test(candidate) && !/^SC\./.test(candidate)) return candidate;
  }
  // If modelId exists somewhere, try to find page after it
  if (modelId) {
    const modelIndex = pathParts.findIndex((p) => p === modelId);
    if (modelIndex >= 0 && modelIndex < pathParts.length - 1) {
      const candidate = pathParts[modelIndex + 1];
      if (candidate && !/^\d{10}$/.test(candidate) && !/^SC\./.test(candidate)) return candidate;
    }
  }
  return fallback;
};

